import React, { useState, useEffect } from 'react';
import { ShopHero } from './ShopHero';
import { ProductGrid } from './ProductGrid';
import { ShopFilter } from './ShopFilter';
import { useNavigate } from 'react-router-dom';
import { products, categories } from './productData';
import { ShoppingCart } from './ShoppingCart';

const Shop = () => {
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [isCartOpen, setIsCartOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
    if (categoryId === 'all') {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter(product => product.category === categoryId));
    }
  };

  const handleProductClick = (productId) => {
    navigate(`/shop/product/${productId}`);
  };

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <div className="pt-20 min-h-screen bg-gray-900">
      {/* Cart Icon */}
      <div className="fixed right-4 top-24 z-50">
        <button 
          onClick={toggleCart}
          className="bg-white p-3 rounded-full shadow-lg hover:bg-gray-100 transition-all"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </button>
      </div>
      
      {/* Shopping Cart Sidebar */}
      <ShoppingCart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      
      {/* Hero Section */}
      <ShopHero />
      
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-white mb-8 text-center">Mūsu Produkti</h2>
        
        {/* Category Filter */}
        <ShopFilter 
          categories={categories} 
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
        />
        
        {/* Product Grid */}
        <ProductGrid 
          products={filteredProducts}
          onProductClick={handleProductClick}
        />
      </div>
    </div>
  );
};

export default Shop; 